import * as React from 'react';
import { Component } from 'react';
import Modal from '../../components/Modal';
import { ModalProps } from '../../components/Modal/presenter';

export type RenderFunction = (props: { openModal: () => void; closeModal: () => void }) => React.ReactNode;

type Props = Omit<ModalProps, 'isOpen' | 'children'> & {
    renderModalContent: RenderFunction;
    children: RenderFunction;
};

interface State {
    isOpen: boolean;
}

/**
 * Component that manages open/closed state for a modal
 *
 * ```
 * <WithModal
 *     {...modalProps}
 *     onClose={handleClose}
 *     renderModalContent={({openModal, closeModal})=><ModalContent onCancel={closeModal} />}
 * >
 *   { ({closeModal, openModal}) => <ModalTriggerComponent onClick={openModal}/> }
 * </WithModal>
 * ```
 */

export default class WithModal extends Component<Props, State> {
    state = {
        isOpen: false,
    };

    actions = {
        openModal: () => {
            this.setState({ isOpen: true });
        },
        closeModal: () => {
            this.setState({ isOpen: false });
            if (this.props.onClose) {
                this.props.onClose();
            }
        },
    };

    render() {
        const { renderModalContent, children: render, ...props } = this.props;
        return (
            <>
                <Modal
                    {...props}
                    isOpen={this.state.isOpen}
                    onClose={this.actions.closeModal}
                    children={renderModalContent(this.actions)}
                />
                {render(this.actions)}
            </>
        );
    }
}
